import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { memo } from 'react';
import type { MouseEvent } from 'react';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { useFormContext } from '../../contexts/FormContext';
import { useFieldValue } from '../../hooks/useFormValues';
import type { FieldComponentProps } from '../form-engine/types';

const ButtonGroupField = ({ field }: FieldComponentProps) => {
  const { handleChange } = useFormContext();

  const selectedValue = useFieldValue(field.name!);

  const handleButtonChange = (_event: MouseEvent<HTMLElement>, newValue: unknown) => {
    if (newValue !== null) {
      handleChange(
        {
          target: {
            name: field.name!,
            value: newValue,
            type: 'select',
          },
        },
        field,
      );
    }
  };

  return (
    <Grid size={field.size || 12} key={field.name}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <ToggleButtonGroup
            value={selectedValue}
            exclusive
            onChange={handleButtonChange}
            aria-label={field.label}
            fullWidth
            disabled={!!field.disabled}
            color="primary"
          >
            {field.options!.map((option) => (
              <ToggleButton
                key={option.value}
                value={option.value}
                sx={{
                  flex: 1,
                  textTransform: 'none',
                  position: 'relative',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {option.label}
                  {!!option.help && <ChartHelpTooltip chartType={option.help as string} type="label" />}
                </Box>
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      </Box>
    </Grid>
  );
};

export default memo(ButtonGroupField);
